<template>
    <b-overlay :show="isLoading">
        <b-card class="m-4">
            <ValidationObserver ref="observer" v-slot="{ passes }">
                <b-form @submit.prevent="passes(saveUser)" id="user-form">
                    <h3><font-awesome-icon icon="user-circle"></font-awesome-icon> Datos generales</h3>
                    <b-row class="mb-2">
                        <b-col cols="12" md="4" class="text-left">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="Nombre" invalid-feedback="Ingresa el nombre">
                                    <b-form-input v-model="user.name" autocomplete="false" placeholder="Nombre"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-left">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="Usuario" invalid-feedback="Ingresa el usuario">
                                    <b-form-input v-model="user.username" autocomplete="false" placeholder="Usuario"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-left">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="Correo" invalid-feedback="Ingresa el correo">
                                    <b-form-input v-model="user.email" autocomplete="false" placeholder="Correo"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="12" md="4" class="text-left">
                            <b-form-group label="Teléfono 1">
                                <b-form-input v-model="user.phone1" autocomplete="false" placeholder="Teléfono 1"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4" class="text-left">
                            <b-form-group label="Teléfono 2">
                                <b-form-input v-model="user.phone2" autocomplete="false" placeholder="Teléfono 2"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4" class="text-left">
                            <ValidationProvider :rules="$route.name === 'UserNew' || $route.name === 'PortalUserNew' ? 'required' : ''" v-slot="{ errors }">
                                <b-form-group label="Contraseña">
                                    <b-input-group>
                                        <b-form-input v-model="user.password" autocomplete="false" :type=" showPassword ? 'text' : 'password'"
                                                      placeholder="Contraseña" :state="errors[0] ? false : null"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :variant="errors[0] ? 'outline-danger' : 'outline-primary'" v-b-tooltip.hover
                                                      title="Mostrar contraseña" @click="showPassword = true" @mouseout="showPassword = false"
                                                      style="border-top-right-radius: .25rem !important; border-bottom-right-radius: .25rem !important;">
                                                <font-awesome-icon icon="eye"></font-awesome-icon>
                                            </b-button>
                                        </b-input-group-append>
                                        <b-form-invalid-feedback class="text-left">Ingresa la contraseña</b-form-invalid-feedback>
                                    </b-input-group>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <!--                        <b-col cols="12" md="4" class="text-left" v-if="isBackOfficeUser">-->
                        <!--                            <b-form-group label="Tipo de usuario">-->
                        <!--                                <b-form-radio-group v-model="user.role" :options="roles"></b-form-radio-group>-->
                        <!--                            </b-form-group>-->
                        <!--                        </b-col>-->
                        <!--                        <b-col cols="12" v-if="isPortalUser" class="text-left">-->
                        <!--                            <b-row class="mt-2">-->
                        <!--                                <b-col cols="12" md="6" lg="4" v-for="group in groups" :key="group.id">-->
                        <!--                                    <b-list-group>-->
                        <!--                                        <b-list-group-item class="py-1">-->
                        <!--                                            <b-form-checkbox :value="group.id" v-model="user.groupIds">{{ group.name }}</b-form-checkbox>-->
                        <!--                                        </b-list-group-item>-->
                        <!--                                        <b-list-group-item v-for="subgroup in group.subgroups" :key="subgroup.id" class="py-1">-->
                        <!--                                            <b-form-checkbox :value="subgroup.id" v-model="user.groupIds"-->
                        <!--                                                             :class="subgroup.level === 2 ? 'ml-4' : 'ml-5'">{{ subgroup.name }}</b-form-checkbox>-->
                        <!--                                        </b-list-group-item>-->
                        <!--                                    </b-list-group>-->
                        <!--                                </b-col>-->
                        <!--                            </b-row>-->
                        <!--                        </b-col>-->
                        <b-col v-if="isPortalUser" cols="12" md="8" class="text-left">
                            <b-form-group label="Grupos">
                                <v-select label="name" :options="groups" debounce="300" placeholder="Grupos"
                                          @search="getGroups" @search:focus="getGroups"
                                          :filterable="false" v-model="user.groups" multiple>
                                    <template slot="no-options">Sin resultados.</template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">{{ option.name }}</div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">{{ option.name }}</div>
                                    </template>
                                </v-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="isBackOfficeUser">
                        <b-col cols="12" md="4" class="text-left">
                            <b-form-group label="Puesto">
                                <b-form-input v-model="user.jobPosition" autocomplete="false" placeholder="Puesto"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col v-if="showSignatureField" cols="12" md="4" class="text-left">
                            <b-form-group label="Firma">
                                <b-form-file v-model="file" placeholder="Firma" accept="image/jpeg, image/png, image/jpg"
                                             browse-text="Seleccionar firma"></b-form-file>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>
            <b-row v-if="isBackOfficeUser">
                <b-col v-if="oldSignature" cols="12" md="6" :offset-md="signature ? 0 : 3" lg="4" :offset-lg="signature ? 2 : 4">
                    <b-card title="Firma actual" class="mb-2">
                        <b-img :src="oldSignature" alt="Firma actual"></b-img>
                    </b-card>
                </b-col>
                <b-col v-if="signature" cols="12" md="6" :offset-md="oldSignature ? 0 : 3" lg="4" :offset-lg="oldSignature ? 0 : 4">
                    <b-card title="Nueva firma" class="mb-2">
                        <b-img :src="signature" alt="Firma" style="max-width: 100%;"></b-img>
                    </b-card>
                </b-col>
            </b-row>
            <template v-slot:footer>
                <div class="text-right">
                    <b-button variant="outline-secondary" :to="backUrl" class="mr-2"><font-awesome-icon icon="angle-left"></font-awesome-icon> Regresar</b-button>
                    <b-button type="submit" form="user-form" variant="primary"><font-awesome-icon icon="save"></font-awesome-icon> Guardar</b-button>
                </div>
            </template>
        </b-card>
    </b-overlay>
</template>

<script>
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { userUrl, groupListUrl, customerUrl } from '@routes';
import * as constants from '@constants';

extend('required', {
    ...required,
    message: 'Campo requerido'
});

export default {
    props: {
        application: String,
        modules: Array
    },
    data() {
        return {
            user: {
                id: 0,
                name: '',
                username: '',
                email: '',
                phone1: '',
                phone2: '',
                password: '',
                role: 'ROLE_BACK_OFFICE_USER',
                groups: [],
                jobPosition: ''
            },
            roles: [
                { text: 'Normal', value: 'ROLE_BACK_OFFICE_USER' },
                { text: 'Administrador', value: 'ROLE_BACK_OFFICE_ADMIN' }
            ],
            groups: [],
            userType: '',
            showPassword: false,
            userGroups: [],
            swalTitle: 'Administradores',
            breadcrumbItems: [],
            action: 'Nuevo',
            signature: null,
            oldSignature: null,
            isLoading: false,
            file: null
        }
    },
    created() {
        if (this.$route.name.includes('Portal')) {
            this.userType = constants.PORTAL_USER;

            this.loadGroups();
            this.getCustomer();

            this.swalTitle = 'Usuarios';
        } else {
            this.userType = constants.BACK_OFFICE_USER;

            this.breadcrumbItems.push(
                {
                    text: 'Configuración',
                    to: { name: 'Settings' }
                },
                {
                    text: 'Administradores',
                    to: { name: 'Settings' }
                }
            );
        }

        if (this.$route.name.includes('Edit')) {
            this.loadData();

            this.action = 'Modificar';
        }

        if (!this.$route.name.includes('Portal')) {
            this.breadcrumbItems.push({
                text: `${this.action} administrador`,
                active: true
            });

            this.$emit('update-breadcrumb-items', this.breadcrumbItems);
        }
    },
    methods: {
        loadData() {
            this.isLoading = true;

            this.axios.get(userUrl(), {
                params: {
                    id: this.$route.params.id,
                    application: this.userType
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    let user = response.data.user;

                    this.user.id = user.id;
                    this.user.name = user.name;
                    this.user.username = user.username;
                    this.user.email = user.email;
                    this.user.phone1 = user.phone1;
                    this.user.phone2 = user.phone2;
                    this.user.groups = user.groups;
                    this.user.jobPosition = user.jobPosition;

                    this.oldSignature = user.signature ?? null;
                }
            }).finally(() => {
                this.isLoading = false;
            });
        },
        loadGroups() {
            this.axios.get(groupListUrl(), {
                params: {
                    customerId: this.$route.params.customerId
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    let array = response.data.groups;
                    let groups = [];

                    for (let group of array) {
                        groups.push({
                            id: group.id,
                            name: group.name,
                            level: group.level
                        });

                        for (let child of group.children) {
                            groups.push({
                                id: child.id,
                                name: child.name,
                                level: child.level
                            });

                            for (let child of child.children) {
                                groups.push({
                                    id: child.id,
                                    name: child.name,
                                    level: child.level
                                });
                            }
                        }
                    }

                    this.groups = groups;
                } else {
                    this.groups = [];
                }
            }).catch(() => {
                this.groups = [];
            });
        },
        saveUser() {
            let title = '¿Guardar los cambios?';

            if (this.user.id === 0) {
                title = `¿Guardar el ${this.isPortalUser ? 'usuario' : 'administrador'}?`;
            }

            this.$swal({
                title: title,
                icon: 'question'
            }).then(result => {
                if (result.value) {
                    this.isLoading = true;

                    let formData = new FormData();

                    formData.append('file', this.file);

                    let data = {
                        application: this.userType,
                        user: {
                            id: this.user.id,
                            name: this.user.name,
                            email: this.user.email,
                            phone1: this.user.phone1,
                            phone2: this.user.phone2,
                            username: this.user.username,
                            password: this.user.password, // TODO send always or only if not empty?
                            jobPosition: this.user.jobPosition
                        }
                    };

                    if (this.isPortalUser) {
                        data.customerId = this.$route.params.customerId;
                        data.user.groupIds = this.user.groups.map(group => group.id);
                    } else {
                        data.user.roles = [ this.user.role ];
                    }

                    formData.append('data', JSON.stringify(data));

                    // const method =  this.user.id === 0 ? 'post' : 'put';

                    this.axios.post(userUrl(), formData).then(response => {
                        if (response.data.code === constants.CODE_OK) {
                            this.$root.$bvToast.toast(response.data.message, {
                                title: this.swalTitle,
                                variant: 'success'
                            });

                            if (this.isPortalUser) {
                                this.$router.push({ name: 'CustomerShow', params: { id: this.$route.params.customerId }});
                            } else {
                                this.$router.push({ name: 'Settings' });
                            }
                        } else {
                            this.$bvToast.toast(response.data.message, {
                                title: this.swalTitle,
                                variant: 'danger'
                            });
                        }
                    }).catch(error => {
                        console.error(error);

                        this.$bvToast.toast('Ocurrió un error al guardar los cambios.', {
                            title: this.swalTitle,
                            variant: 'danger'
                        });
                    }).finally(() => {
                        this.isLoading = false;
                    });
                }
            });
        },
        getCustomer() {
            this.axios.get(customerUrl(), {
                params: {
                    customerId: this.$route.params.customerId
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    this.breadcrumbItems.push(
                        {
                            text: 'Clientes',
                            to: { name: 'Customer' }
                        },
                        {
                            text: response.data.customer.legalName,
                            to: { name: 'CustomerShow', params: { id: this.$route.params.customerId }}
                        },
                        {
                            text: `${this.action} usuario`,
                            active: true
                        }
                    );

                    this.$emit('update-breadcrumb-items', this.breadcrumbItems);
                }
            });
        },
        getGroups(search = '', loading = null) {
            if (loading) {
                loading(true);
            }

            this.axios.get(groupListUrl(), {
                params: {
                    searchWord: search,
                    customerId: this.$route.params.customerId
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    this.groups = response.data.groups;
                } else {
                    this.groups = [];
                }
            }).catch(() => {
                this.groups = [];
            }).finally(() =>  {
                if (loading) {
                    loading(false);
                }
            });
        },
        getSignatureBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        }
    },
    computed: {
        isBackOfficeUser() {
            return this.userType === constants.BACK_OFFICE_USER;
        },
        isPortalUser() {
            return this.userType === constants.PORTAL_USER;
        },
        backUrl() {
            let url = { name: 'Settings' };

            if (this.isPortalUser) {
                url = { name: 'CustomerShow', params: { id: this.$route.params.customerId }};
            }

            return url;
        },
        showSignatureField() {
            return this.modules.includes('SIGNING');
        }
    },
    watch: {
        file() {
            this.getSignatureBase64(this.file).then(result => {
                this.signature = result;
            });
        }
    }
}
</script>

<style scoped>
    label {
        font-weight: 700;
    }
</style>